import { map, scan } from "@pdfking/rfunc"
import { IsString } from "@pdfking/tfunc"
import selector from "./selector"

export default (
  elements: Element | Element[] | string,
  content: (Node | string)[] | Node | string
): ((Node | string)[] | Node | string)[] => {
  return map((el: Element) => {
    scan<Node | string>((c: Node | string) => {
      if (IsString(c)) {
        el.innerHTML += c
      } else {
        el.appendChild(c)
      }
    }, content as any)
    return content
  }, selector(elements))
}
